<template>
  <div class="p-site-keyword-analysis-checked">
    <p class="p-site-keyword-analysis-checked__count">
      選択中のキーワード数 : <strong>{{ count }}</strong>
    </p>
    <Button variant="border" fsize="f12" size="w120" @click="reset">
      <Icon variant="return_gn" :size="12" />
      選択を解除する
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon from '@/components/Icon';

export default {
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  components: {
    Button,
    Icon
  },
  methods: {
    reset() {
      this.$emit('reset');
    }
  }
};
</script>
